module.exports = __webpack_public_path__ + "static/media/setnickname.063ea05f.gif";